import { render, staticRenderFns } from "./gCard.vue?vue&type=template&id=16337ed9&scoped=true&"
import script from "./gCard.vue?vue&type=script&lang=js&"
export * from "./gCard.vue?vue&type=script&lang=js&"
import style0 from "./gCard.vue?vue&type=style&index=0&id=16337ed9&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16337ed9",
  null
  
)

export default component.exports